/**
 * @file FormModel Controller
 */

'use strict';
import Listener from '../Utils/Listener';
import Common from '../Utils/Common';

let instance = null;

/**
 * @classname FormModel
 * @classdesc Basic Model
 */
export default class FormModel {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}

		this._listener = new Listener();
		this._jqXHR = null;
		this._post = false;
		this._data = null;
		this._message = null;
		this._code = null;

		this._couponError = false;
		this._isSelectedCoupon = false;

		// csrf add
		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});

		instance = this;
		return instance;
	};


	/**
	 * お気に入り
	 *
	 * @memberof FormModel
	 * @param {string} itemId - 商品ID
	 * @param {boolean} flg - 登録フラグ
	 * @return {undefined}
	 */
	favorite(itemId, flg) {
		if (this._post) return;
		console.log(`FormModel.favorite`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('item_id', itemId);
		let url;
		if(flg){
			url = window.const.API_URL.FAVORITE_ON;
		}else{
			url = window.const.API_URL.FAVORITE_OFF;
		}
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onFavoriteComplete.bind(this));
	};


	/**
	 * お気に入り登録・解除完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onFavoriteComplete(data, textStatus, xhr) {
		console.log('FormModel.onFavoriteComplete');
		Common.hideLoading();
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onFavoriteComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onFavoriteComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * 子カテゴリー取得
	 *
	 * @memberof FormModel
	 * @param {string} categoryId - カテゴリーID
	 * @param {number} level - カテゴリー階層レベル
	 * @return {undefined}
	 */
	getChildCategories(categoryId, level) {
		if (this._post) return;
		console.log(`FormModel.getChildCategories`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('category_id', categoryId);
		formData.append('category_level', level);
		let url = window.const.API_URL.GET_CHILD_CATEGORIES;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onGetChildCategoriesComplete.bind(this));
	};


	/**
	 * 子カテゴリー取得完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onGetChildCategoriesComplete(data, textStatus, xhr) {
		console.log('FormModel.onGetChildCategoriesComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onGetChildCategoriesComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onGetChildCategoriesComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * カート追加
	 *
	 * @memberof FormModel
	 * @paran {number} stockId - 在庫ID
	 * @return {undefined}
	 */
	AddCart(stockId) {
		if (this._post) return;
		console.log(`FormModel.AddCart`);
		Common.showLoading();
		this._post = true;
		const quantity = $('#quantity').val();
		let formData = new FormData();
		formData.append('item_stock_id', stockId);
		formData.append('quantity', quantity);
		let url = window.const.API_URL.ADD_CART;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onAddCartComplete.bind(this));
	};


	/**
	 * カート追加完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onAddCartComplete(data, textStatus, xhr) {
		console.log('FormModel.onAddCartComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onAddCartComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onAddCartComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * カート数量変更
	 *
	 * @memberof FormModel
	 * @param {string} itemStockId - 商品ID
	 * @param {string} quantity - 数量
	 * @return {undefined}
	 */
	ChangeCartQuantity(itemStockId, quantity) {
		if (this._post) return;
		console.log(`FormModel.ChangeCartQuantity`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		this._itemStockId = itemStockId;
		this._quantity = quantity;
		formData.append('item_stock_id', itemStockId);
		formData.append('quantity', quantity);
		let url = window.const.API_URL.UPDATE_CART;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onChangeCartQuantityComplete.bind(this));
	};


	/**
	 * カート数量変更完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onChangeCartQuantityComplete(data, textStatus, xhr) {
		console.log('FormModel.onChangeCartQuantityComplete');
		Common.hideLoading();
		console.log(data);
		console.log(xhr);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onChangeCartQuantityComplete');
				//this.reCalculateCart();
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onChangeCartQuantityComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * 再計算（カート）
	 *
	 * @memberof FormModel
	 * @param {string} couponId - クーポンId
	 * @return {undefined}
	 */
	reCalculateCart(couponId= null) {
		if (this._post) return;
		console.log(`FormModel.reCalculate`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		const deliveryAddressCount = $('#delivery_address_count').val();
		let url = window.const.API_URL.CALCULATE;
		formData.append('delivery_address_count', '1');
		const $area = $(`[data-stock-id=${this._itemStockId}]`).closest('.area--cart');
		const cartNo = $area.attr('data-cart-no');
		const receiverItemCount = $area.find('.list__item').length;
		formData.append(`receiver_item_count[${cartNo}]`, receiverItemCount);
		$area.find('.list__item').each((idx, e) => {
			const $e = $(e);
			const itemStockId = $e.attr('data-stock-id');
			formData.append(`item_stock_id[${cartNo}][${idx + 1}]`, itemStockId);
			const quantity = $e.find('.quantity').val();
			formData.append(`quantity[${cartNo}][${idx + 1}]`, quantity);
		});
		Common.logFormData(formData);
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onReCalculateCartComplete.bind(this));
	};


	/**
	 * 再計算（カート）完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onReCalculateCartComplete(data, textStatus, xhr) {
		console.log('FormModel.onReCalculateCartComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onReCalculateCartComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onReCalculateCartComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * カート商品削除
	 *
	 * @memberof FormModel
	 * @param {string} stockId - 在庫ID
	 * @return {undefined}
	 */
	CartDelete(stockId) {
		if (this._post) return;
		console.log(`FormModel.CartDelete`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('item_stock_id', stockId);
		let url = window.const.API_URL.DELETE_CART;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onCartDeleteComplete.bind(this));
	};


	/**
	 * カート商品削除完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onCartDeleteComplete(data, textStatus, xhr) {
		console.log('FormModel.onCartDeleteComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onCartDeleteComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onCartDeleteComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * 市区町村取得
	 *
	 * @memberof FormModel
	 * @param {string} couponCode - クーポンコード
	 * @return {undefined}
	 */
	applyCoupon(couponCode) {
		if (this._post) return;
		console.log(`FormModel.applyCoupon`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('coupon_code', couponCode);
		let url = window.const.API_URL.APPLY_COUPON;
		// ここからはデバッグ用のURL
		/*if(couponCode === '__WRONG__COUPON__'){
			this._couponError = true;
			console.log('this._couponError = true')
		}*/
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onApplyCouponComplete.bind(this));
	};


	/**
	 * クーポン適用完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onApplyCouponComplete(data, textStatus, xhr) {
		console.log('FormModel.onApplyCouponComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onApplyCouponComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onApplyCouponComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * クーポン利用
	 *
	 * @memberof FormModel
	 * @param {string} couponId - クーポンID
	 * @return {undefined}
	 */
	applySelectedCoupon(couponId) {
		if (this._post) return;
		console.log(`FormModel.applySelectedCoupon`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		formData.append('coupon_id', couponId);
		let url = window.const.API_URL.APPLY_SELECTED_COUPON;
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onApplySelectedCouponComplete.bind(this));
	};


	/**
	 * クーポン適用完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onApplySelectedCouponComplete(data, textStatus, xhr) {
		console.log('FormModel.onApplySelectedCouponComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onApplySelectedCouponComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onApplySelectedCouponComplete): ${textStatus}`);
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * 再計算
	 *
	 * @memberof FormModel
	 * @param {string} couponId - クーポンId
	 * @return {undefined}
	 */
	reCalculate(couponId= null, isSelectedCoupon = false) {
		if (this._post) return;
		console.log(`FormModel.reCalculate/ couponId: ${couponId}`);
		Common.showLoading();
		this._post = true;
		let formData = new FormData();
		const deliveryAddressCount = $('#delivery_address_count').val();
		let url = window.const.API_URL.CALCULATE2;
		if(couponId) {
			url = window.const.API_URL.CALCULATE;
			formData.append('coupon_id', couponId);
		}
		/*if(this._couponError){
			url = window.const.API_URL.CALCULATE4;
		}*/
		console.log('URL: ' + url);
		this._couponError = false;
		this._isSelectedCoupon = isSelectedCoupon;
		formData.append('delivery_address_count', deliveryAddressCount);
		$('.receiver_item_count').each((idx, e) => {
			const $e = $(e);
			formData.append($e.attr('name'), $e.val());
		});
		$('.item_stock_id').each((idx, e) => {
			const $e = $(e);
			formData.append($e.attr('name'), $e.val());
		});
		$('.quantity').each((idx, e) => {
			const $e = $(e);
			formData.append($e.attr('name'), $e.val());
		});
		Common.logFormData(formData);
		let params = {};
		params['data'] = formData;
		params['method'] = 'POST';
		params['dataType'] = 'json';
		params['url'] = url;
		params['processData'] = false;
		params['contentType'] = false;
		console.log(JSON.stringify(params));
		this._jqXHR = $.ajax(params).always(this.onReCalculateComplete.bind(this));
	};


	/**
	 * 再計算完了
	 *
	 * @memberof FormModel
	 * @param {Object} data - data|jqXHR
	 * @param {String} textStatus - "success", "notmodified", "nocontent", "error", "timeout", "abort", or "parsererror"
	 * @param {number} xhr - XMLHttpRequest
	 * @return {undefined}
	 */
	onReCalculateComplete(data, textStatus, xhr) {
		console.log('FormModel.onReCalculateComplete');
		Common.hideLoading();
		console.log(data);
		this._data = data.result;
		this._code = data.success;
		this._message = data.message;
		console.log(`code: ${this._code} / message: ${this._message}`);
		if (data.status == 422) {
			// laravel validate errorの時
			this._post = false;
			Common.showErrorModal(data.responseJSON.message);
			if (this._isSelectedCoupon) {
				this._listener.trigger('onApplySelectedCouponError');
			}
			this._listener.trigger('onError');
		}else if (textStatus === 'success') {
			if (this._code !== 1) {
				this._post = false;
				Common.showErrorModal(this._message);
				if (this._isSelectedCoupon) {
					this._listener.trigger('onApplySelectedCouponError');
				}
				this._listener.trigger('onError');
			} else {
				this._post = false;
				this._listener.trigger('onReCalculateComplete');
			}
		} else {
			this._post = false;
			this._code = 9999;
			this._message = `（${data.status}）<br>通信エラーが発生しました。<br>再度お試しください。`;
			Common.showErrorModal(this._message);
			console.log(`ajax error (onReCalculateComplete): ${textStatus}`);
			if (this._isSelectedCoupon) {
				this._listener.trigger('onApplySelectedCouponError');
			}
			this._listener.trigger('onError');
		}
		this._jqXHR = null;
	};


	/**
	 * listener on
	 *
	 * @memberof FormModel
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listener off
	 *
	 * @memberof FormModel
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};
}
